import { Component, inject, OnInit } from '@angular/core';
import { GlobalService } from '@core/services/global.service';
import { IVersion } from '@devinforius/i-essentials';
import { Support } from '@shared/models/global.model';

@Component({
  standalone: false,
  selector: 'app-assistance',
  templateUrl: './assistance.component.html',
  styleUrl: './assistance.component.scss',
})
export class AssistanceComponent implements OnInit {
  private readonly globalService: GlobalService = inject(GlobalService);
  public support: Support | null = null;

  public ngOnInit(): void {
    this.globalService.getSupport().subscribe({
      next: (data: Support) => {
        console.log('Service data loaded successfully:', data);
        this.support = data;
      },
      error: (error) => {
        console.error('Error loading service data:', error);
      },
    });
  }

  public versions: IVersion[] = [
    {
      number: '1.0.0',
      pdfURL: '',
      shortDescription: 'Description courte',
      latest: true,
    },
  ];
}
